var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationMietrecht(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1600 1200",
    style: {
      enableBackground: "new 0 0 1600 1200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4F4F4;}\n\t.st1{fill:#61656D;}\n\t.st2{opacity:0.2;enable-background:new    ;}\n\t.st3{fill:#B2B6BB;}\n\t.st4{opacity:0.1;enable-background:new    ;}\n\t.st5{opacity:5.000000e-02;enable-background:new    ;}\n\t.st6{fill:#137F7B;}\n\t.st7{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\n\t.st8{opacity:0.15;enable-background:new    ;}\n\t.st9{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n\t.st10{fill:#FFFFFF;stroke:#D6D6D6;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st11{fill:#FFFFFF;}\n\t.st12{fill:#F0F0F0;}\n\t.st13{opacity:0.3;enable-background:new    ;}\n\t.st14{fill:#DADDDF;}\n\t.st15{fill:#868A91;}\n\t.st16{fill:#3F4249;}\n\t.st17{fill:none;stroke:#3F4249;stroke-width:0.73;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st18{fill:#FC9D9D;}\n\t.st19{fill:none;stroke:#3F4249;stroke-width:0.75;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st20{fill:#21252B;}\n\t.st21{opacity:0.5;}\n\t.st22{opacity:0.5;enable-background:new    ;}\n\t.st23{opacity:0.2;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2_00000068654436956183705250000001671444440637456038_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 752.8,
    cy: 892.8,
    rx: 710.9,
    ry: 121.2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M499.1,702.7h-23.7v168.4h23.7V702.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M431.3,688.9c0,0,1.4,50.7,45.4,77.9l-0.4-15.2c0,0-29.2-29-26-53.6L431.3,688.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M545.9,688.9c0,0-3.4,52.6-47.4,79.7l-2.3-17.4c0,0,38.4-25.8,32.5-56.8L545.9,688.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M499.1,705.1h-10.9v166h10.9V705.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M439.8,695.2c0,0,5.2,45.3,35.8,62.2l-0.1-6.5c0,0-26.5-26.1-25.5-51.8C446.7,697.5,443.3,696.2,439.8,695.2 L439.8,695.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M536.3,694.9c0,0,3.8,34.2-37.1,63.6l-0.3-9.3c0,0,32.5-22.6,30-51.4L536.3,694.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M595.7,614.2c-0.3,25.6-10.7,50-28.9,68c-18.2,18-42.7,28-68.3,28c-25.6,0-50.1-10.1-68.3-28 c-18.2-18-28.6-42.4-28.9-68c0-53.7,43.5-167,97.2-167S595.7,560.6,595.7,614.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M560.6,498.2c0.1,2.9,0.2,5.9,0.2,8.9c0,85.8-52.4,155.3-117.1,155.3c-11.3,0-22.5-2.2-33-6.3 c9.5,19.9,25.5,36,45.3,45.6c19.8,9.6,42.4,12.2,63.9,7.4c21.5-4.9,40.7-16.9,54.5-34.1c13.8-17.2,21.3-38.6,21.3-60.7 C595.7,584.1,582.1,535.3,560.6,498.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M596.7,614.5c0-53.4-43.9-165.5-98.5-168.2v266C552.8,711.3,596.7,667.9,596.7,614.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M608.4,667c-0.5,15.6-7.1,30.4-18.4,41.2c-11.3,10.8-26.4,16.6-42.1,16.3c-15.6-0.3-30.5-6.8-41.4-18 c-10.9-11.2-16.9-26.3-16.7-41.9c0.7-32.7,28.6-101.3,61.4-100.7C583.9,564.6,609.1,634.3,608.4,667z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M588.4,595.8c0,1.8,0,3.6,0,5.4c-1.1,52.3-33.9,94-73.3,93.2c-6.9-0.1-13.7-1.6-20.1-4.3 c5.5,12.3,15.1,22.3,27.1,28.4c12,6.1,25.7,8,38.9,5.3c13.2-2.7,25.1-9.8,33.7-20.1c8.6-10.3,13.5-23.3,13.7-36.7 C608.8,648.7,601,618.7,588.4,595.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M609,667.2c0.6-32.6-24.7-101.5-58-103.7l-3.3,162.2C581,725.7,608.3,699.7,609,667.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M478.8,649.6c-0.2,14-6,27.3-15.9,37.1c-10,9.8-23.4,15.3-37.4,15.3c-14,0-27.4-5.5-37.4-15.3 c-10-9.8-15.7-23.1-15.9-37.1c0-29.4,23.9-91.6,53.3-91.6C454.9,558,478.8,620.2,478.8,649.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M459.6,586c0.1,1.5,0.1,3.2,0.1,4.9c0,47-28.7,85.1-64.2,85.1c-6.2,0-12.3-1.2-18.1-3.4 c5.2,10.9,14,19.7,24.8,25c10.9,5.3,23.2,6.7,35,4c11.8-2.7,22.3-9.3,29.9-18.7c7.5-9.4,11.7-21.2,11.7-33.3 C478.8,633.1,471.3,606.4,459.6,586z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M479.3,649.7c0-29.3-24.1-90.7-54-92.2v145.8C455.3,702.8,479.3,679,479.3,649.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1325.2,389.4H957.7v485.8h367.5V389.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1325.2,389.4H957.7v485.8h367.5V389.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1325.2,389.4H958.1v35.9h367.2V389.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1325.2,767H957.7v108.2h367.5V767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M628.6,373.8v501.4h329.1V373.8l-164.5-98.9L628.6,373.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M628.6,373.8v501.4h329.1V373.8l-164.5-98.9L628.6,373.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M957.7,767H628.6v108.2h329.1V767z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M626.8,373.8v34.3l151-94.9L958.2,426v-30.1l-166.9-121L626.8,373.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M575.9,389.4l199.8-130.2l199.7,130.2l-12.6,25.9l-187.2-122l-187.2,122L575.9,389.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M775.7,259.2h415.2l167.3,124.5H965.4L775.7,259.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M962.8,415.3h395.3v-32.9H962.8V415.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M962.8,415.3h395.3v-32.9H962.8V415.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M838.5,422.4H721.3v146.3h117.2V422.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M838.2,422.2H835v146.3h3.3V422.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M827.8,429.6H732v131.9h95.9V429.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M782,431.1h-8.6v130.2h8.6V431.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M732.4,527.6l70.9-97.9h24.1v24.9l-79.9,106.6l-15.2,0.1V527.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M731.9,429.3h-2.9v132h2.9V429.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M782,430.8h-2.9v130.5h2.9V430.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M827.8,523h-98.8v4.7h98.8V523z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M790.3,561.2l37.5-46.8v31.8l-14.4,15.2L790.3,561.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M732.4,463.6l23.9-33.9h24.6l-48.5,62.6V463.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1048.4,565.6h195.8V446.7h-195.8V565.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1048.6,565.3h2.9V446.5h-2.9V565.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1058,559.1h179.1V453.2H1058V559.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1156,452.8h-7.7v106.1h7.7V452.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1212.8,558.4l-111.2-105.2l-43.3-0.7v20l88.7,85.9H1212.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1235.9,558.9h2.6v-106h-2.6V558.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1148.2,558.9h2.6V452.5h-2.6V558.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1108.4,558.4l-50.1-36.5v17.9l25.8,18.6H1108.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1235.7,491.7L1187,454h-30.8l79.5,63.6V491.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1004.8,875.2h155.6V660.8l-155.6-54.7V875.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1004.8,875.2h155.6V660.8l-155.6-54.7V875.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1154.6,791.9h-149.9v83.3h149.9V791.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M1418.9,660.8h-264.2v214.4h264.2V660.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M1418.9,660.8h-264.2v214.4h264.2V660.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1418.9,660.8h-258.6v17.3h258.6V660.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1418.9,791.9h-264.3v83.3h264.3V791.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1004.8,617.3l155.6,60.8v-17.3l-155.6-54.7V617.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M992.5,587.1h284.6l157.4,70.6h-270L992.5,587.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1160.8,672.7h273.2l0.6-15.6l-273-1.3L1160.8,672.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1160.8,672.7h273.2l0.6-15.6l-273-1.3L1160.8,672.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M1039.7,611.2l-47.2-24.1h284.6l42.9,24.1H1039.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M993.2,587.6l168.5,68.1l-0.8,16.9l-168.3-69L993.2,587.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1180.9,875.3h209V714.2h-209V875.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1191.1,875.3h190V721.5h-190V875.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,867.6h190v-5.2h-190V867.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,856.3h190v-5.2h-190V856.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,844.9h190v-5.2h-190V844.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,833.5h190v-5.2h-190V833.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,822.2h190V817h-190V822.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,810.8h190v-5.2h-190V810.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,799.5h190v-5.2h-190V799.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,788.1h190V783h-190V788.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,776.8h190v-5.2h-190V776.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,765.4h190v-5.2h-190V765.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,754.1h190v-5.2h-190V754.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,742.7h190v-5.2h-190V742.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1191.1,731.4h190v-5.2h-190V731.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1180.6,714.7v161.2l2.5-0.2v-161H1180.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1381,721.1v154.3l2.5-0.2V721.1H1381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1299.7,867.6h-30.1v2.9h30.1V867.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1115.5,682.8h-77.9v97.2h77.9V682.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1115.3,682.7h-2.2v97.2h2.2V682.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M1108.4,687.6h-63.7v87.7h63.7V687.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1078,688.6h-5.7v86.6h5.7V688.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1045,752.8l47.1-65.1h16v16.5L1055,775l-10.1,0V752.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1044.7,687.4h-1.9v87.7h1.9V687.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M1078,688.4h-1.9v86.8h1.9V688.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M1108.4,749.7h-65.6v3.1h65.6V749.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1083.5,775.1l25-31.1v21.2l-9.6,10.1L1083.5,775.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M1045,710.2l15.9-22.5h16.4l-32.3,41.6V710.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M549.1,674.3h248.6l120-61.5H669L549.1,674.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M797.6,674.3l2,16.5l120-61.5l-2-16.5L797.6,674.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M797.6,674.3l2,16.5l120-61.5l-2-16.5L797.6,674.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M799.1,674.3l0.6,16.5H551.1l-2-16.5H799.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M820.7,863.3V708.7h-85.9v154.6H820.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M813.5,863.8V714.2h-71.6v149.6H813.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M754.5,763.3h43.7v-35.7h-43.7V763.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M820.7,708.7h-2.9v154.6h2.9V708.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M741.9,714.4h-2.9v148.9h2.9V714.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M802.8,788.9c2,0,3.6-1.6,3.6-3.6c0-2-1.6-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6 C799.2,787.3,800.8,788.9,802.8,788.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M802.8,781.7c-0.3,0-0.6,0.1-0.9,0.1c0.8,0.2,1.4,0.6,1.9,1.3c0.5,0.6,0.7,1.4,0.7,2.2s-0.3,1.6-0.7,2.2 c-0.5,0.6-1.2,1.1-1.9,1.3c0.3,0.1,0.6,0.1,0.9,0.1c0.5,0,1,0,1.4-0.2c0.5-0.2,0.9-0.4,1.2-0.8c0.4-0.3,0.6-0.7,0.8-1.2 c0.2-0.5,0.3-0.9,0.3-1.4c0-0.5-0.1-1-0.3-1.4c-0.2-0.5-0.5-0.9-0.8-1.2c-0.4-0.3-0.8-0.6-1.2-0.8 C803.8,781.7,803.3,781.7,802.8,781.7L802.8,781.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M754.5,745.2l13.1-17.6h14.9l-28,35.4V745.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M755.9,727.3h-1.4v35.8h1.4V727.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M771.5,763.3l26.7-33.6v14.6l-15.6,19.1H771.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M558.3,875.2h399.8v-11.7H558.3V875.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M826.4,875.2h131.7v-11.7H826.4V875.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M899.7,639.2v224.1h6.7h6.7h6.7V627.7L899.7,639.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M570.1,863.3h13.5V690.7h-13.5V863.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M576.8,863.3h13.5V690.7h-13.5V863.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M736.1,863.8h8.7V789h-8.7V863.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M740.5,863.8h4.4V789h-4.4V863.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M710.5,863.8h8.5V789h-8.5V863.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M714.8,863.8h4.7V789h-4.7V863.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M684.9,863.8h8.4V789h-8.4V863.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M688.7,863.8h4.6V789h-4.6V863.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M659.3,863.8h8.2V789h-8.2V863.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M663.2,863.8h4.3V789h-4.3V863.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M633.5,863.8h8.2V789h-8.2V863.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M637.5,863.8h4.3V789h-4.3V863.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M607.8,863.8h8.2V789h-8.2V863.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M611.7,863.8h4.3V789h-4.3V863.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M577.3,795.1h197v-7.7h-197V795.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M760.9,863.3h13.5V690.7h-13.5V863.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M767.6,863.3H781V690.7h-13.5V863.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M910.8,863.3h9.1V627.1l-9.1,5.7V863.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M580.2,863.3h10.1V690.7h-10.1V863.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M772,863.3h9V690.7h-9V863.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1451.7,705.8h-23.7v168.4h23.7V705.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1383.9,692c0,0,1.4,50.7,45.4,77.9l-0.4-15.2c0,0-29.2-29-26-53.6L1383.9,692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1498.4,692c0,0-3.4,52.6-47.4,79.7l-2.3-17.4c0,0,38.4-25.8,32.6-56.8L1498.4,692z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1451.7,708.2h-10.9v166h10.9V708.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1392.4,698.3c0,0,5.2,45.3,35.8,62.2l-0.1-6.5c0,0-26.5-26.1-25.5-51.8 C1399.3,700.6,1395.9,699.3,1392.4,698.3L1392.4,698.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1488.9,698c0,0,3.8,34.2-37.1,63.6l-0.3-9.3c0,0,32.5-22.6,30-51.4L1488.9,698z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1548.3,617.3c-0.3,25.6-10.7,50-28.9,68c-18.2,18-42.8,28-68.3,28c-25.6,0-50.1-10.1-68.3-28 c-18.2-18-28.6-42.4-28.9-68c0-53.7,43.5-167,97.2-167S1548.3,563.6,1548.3,617.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1513.1,501.3c0.1,2.9,0.2,5.9,0.2,8.9c0,85.8-52.4,155.3-117.1,155.3c-11.3,0-22.5-2.2-33-6.3 c9.5,19.9,25.5,36,45.3,45.6c19.8,9.6,42.4,12.2,63.9,7.4c21.5-4.9,40.7-16.9,54.5-34.1c13.8-17.2,21.3-38.6,21.3-60.7 C1548.3,587.2,1534.6,538.4,1513.1,501.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1549.3,617.6c0-53.4-43.9-165.5-98.5-168.2v266C1505.4,714.4,1549.3,671,1549.3,617.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1561,670.1c-0.5,15.6-7.1,30.4-18.4,41.2c-11.3,10.8-26.4,16.6-42,16.3c-15.6-0.3-30.5-6.8-41.4-18 c-10.9-11.2-16.9-26.3-16.7-41.9c0.7-32.7,28.6-101.3,61.4-100.7C1536.5,567.7,1561.6,637.3,1561,670.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1541,598.9c0,1.8,0,3.6,0,5.4c-1.1,52.3-33.9,94-73.3,93.2c-6.9-0.1-13.7-1.6-20.1-4.3 c5.5,12.3,15.1,22.3,27.1,28.4c12,6.1,25.7,8,38.9,5.3c13.2-2.7,25.1-9.8,33.7-20.1c8.6-10.3,13.5-23.3,13.7-36.7 C1561.3,651.8,1553.6,621.8,1541,598.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1561.5,670.3c0.6-32.6-24.7-101.5-58-103.7l-3.3,162.2C1533.6,728.8,1560.9,702.8,1561.5,670.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1431.4,652.7c-0.2,14-6,27.3-15.9,37.1c-10,9.8-23.4,15.3-37.4,15.3c-14,0-27.4-5.5-37.4-15.3 c-10-9.8-15.7-23.1-15.9-37.1c0-29.4,23.9-91.6,53.3-91.6C1407.5,561.1,1431.4,623.3,1431.4,652.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1412.1,589.1c0,1.5,0.1,3.2,0.1,4.9c0,47-28.7,85.1-64.2,85.1c-6.2,0-12.3-1.2-18.1-3.4 c5.2,10.9,14,19.7,24.9,25c10.9,5.3,23.2,6.7,35,4c11.8-2.7,22.3-9.3,29.9-18.7c7.6-9.4,11.7-21.2,11.7-33.3 C1431.4,636.2,1423.9,609.5,1412.1,589.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1431.9,652.8c0-29.3-24.1-90.7-54-92.2v145.8C1407.8,705.9,1431.9,682.1,1431.9,652.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M330,989.2l409.1-113.3h78.7L572.6,988.4L330,989.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M691,889.3h97.8l-6.3,2.9H680.6L691,889.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M633.8,904.7l113.3,3.1l-6.3,2.9l-117.4-3.1L633.8,904.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M570.4,923.3l136.5,3.1l-6.3,2.9L560,926.1L570.4,923.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M483.8,946.5l162.7,7.7l-6.3,2.9l-166.9-7.7L483.8,946.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M598.3,337.2c-2.3,0.2-4.7-0.3-6.7-1.3c-1.2-0.6-2.2-1.4-3.2-2.3l-0.8-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M595.3,347.8v15.5l3.5,2l1.6-1.2v-1.4l-1.3-0.8l1.3-1v-2.3l-2.2-1.3l2.1-1.5v-2.7l-2.2-1.3l2.1-1.5v-2.2 c1.8-0.5,3.3-1.6,4.4-3.1c1-1.5,1.5-3.3,1.3-5.2c-0.2-1.8-1-3.5-2.3-4.8c-1.3-1.3-3.1-2-4.9-2.1c-1.8-0.1-3.6,0.4-5.1,1.5 c-1.5,1.1-2.5,2.7-2.9,4.5c-0.4,1.8-0.1,3.7,0.7,5.3c0.9,1.6,2.3,2.9,4,3.6L595.3,347.8z M600.3,337.1c0,0.4-0.1,0.9-0.3,1.2 c-0.2,0.4-0.6,0.7-1,0.8c-0.4,0.2-0.9,0.2-1.3,0.2c-0.4-0.1-0.8-0.3-1.2-0.6c-0.3-0.3-0.5-0.7-0.6-1.1c-0.1-0.4-0.1-0.9,0.1-1.3 c0.2-0.4,0.4-0.8,0.8-1c0.4-0.3,0.8-0.4,1.2-0.4c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.4,0.4,0.5,0.7 C600.2,336.5,600.3,336.8,600.3,337.1L600.3,337.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M595.3,347.8v15.5l3.5,2l1.6-1.2v-1.4l-1.3-0.8l1.3-1v-2.3l-2.2-1.3l2.1-1.5v-2.7l-2.2-1.3l2.1-1.5v-2.2 c1.8-0.5,3.3-1.6,4.4-3.1c1-1.5,1.5-3.3,1.3-5.2c-0.2-1.8-1-3.5-2.3-4.8c-1.3-1.3-3.1-2-4.9-2.1c-1.8-0.1-3.6,0.4-5.1,1.5 c-1.5,1.1-2.5,2.7-2.9,4.5c-0.4,1.8-0.1,3.7,0.7,5.3c0.9,1.6,2.3,2.9,4,3.6L595.3,347.8z M600.3,337.1c0,0.4-0.1,0.9-0.3,1.2 c-0.2,0.4-0.6,0.7-1,0.8c-0.4,0.2-0.9,0.2-1.3,0.2c-0.4-0.1-0.8-0.3-1.2-0.6c-0.3-0.3-0.5-0.7-0.6-1.1c-0.1-0.4-0.1-0.9,0.1-1.3 c0.2-0.4,0.4-0.8,0.8-1c0.4-0.3,0.8-0.4,1.2-0.4c0.3,0,0.6,0,0.9,0.1c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.4,0.4,0.5,0.7 C600.2,336.5,600.3,336.8,600.3,337.1L600.3,337.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M596.1,347.8v16.1l3.2,2l1.6-1.8v-1.4l-1.1-0.8l1-1v-2.3l-1.9-1.3l1.9-1.5v-2.7l-1.9-1.3l1.9-1.5l0.2-2.2 c1.8-0.5,3.3-1.6,4.4-3.1c1-1.5,1.5-3.3,1.3-5.2c-0.2-1.8-1-3.5-2.3-4.8c-1.3-1.3-3.1-2-4.9-2.1c-1.8-0.1-3.6,0.4-5.1,1.5 c-1.5,1.1-2.5,2.7-2.9,4.5c-0.4,1.8-0.1,3.7,0.7,5.3c0.9,1.6,2.3,2.9,4,3.6L596.1,347.8z M601.2,337.1c0,0.6-0.3,1.1-0.7,1.5 c-0.4,0.4-0.9,0.6-1.5,0.6c-0.6,0-1.1-0.2-1.5-0.6c-0.4-0.4-0.7-0.9-0.7-1.5c0-0.6,0.3-1.1,0.7-1.5c0.4-0.4,0.9-0.6,1.5-0.6 c0.6,0,1.1,0.2,1.5,0.6C600.8,336,601.1,336.5,601.2,337.1L601.2,337.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M592.4,340.6c0-1.3,0.4-2.6,1.1-3.6c0.7-1.1,1.7-1.9,2.9-2.4c1.2-0.5,2.5-0.6,3.8-0.4 c1.3,0.3,2.4,0.9,3.4,1.8c0.9,0.9,1.5,2.1,1.8,3.4c0.3,1.3,0.1,2.6-0.4,3.8c-0.5,1.2-1.3,2.2-2.4,2.9c-1.1,0.7-2.3,1.1-3.6,1.1 c-1.7,0-3.4-0.7-4.6-1.9C593.1,344,592.4,342.3,592.4,340.6L592.4,340.6z M592.6,340.6c0,1.3,0.4,2.5,1.1,3.5 c0.7,1,1.7,1.9,2.8,2.3c1.2,0.5,2.4,0.6,3.7,0.4c1.2-0.2,2.4-0.8,3.2-1.7c0.9-0.9,1.5-2,1.7-3.2c0.2-1.2,0.1-2.5-0.4-3.7 c-0.5-1.2-1.3-2.1-2.3-2.8c-1-0.7-2.3-1.1-3.5-1.1c-1.7,0-3.3,0.7-4.5,1.9C593.3,337.3,592.6,338.9,592.6,340.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M596.9,363.3C596.9,363.3,596.9,363.3,596.9,363.3C596.9,363.3,597,363.3,596.9,363.3c0.1,0,0.1-0.1,0.1-0.1 c0,0,0,0,0,0v-14.5c0,0,0-0.1,0-0.1c0,0,0,0-0.1,0c0,0-0.1,0-0.1,0c0,0,0,0,0,0.1v14.6C596.8,363.3,596.8,363.3,596.9,363.3 C596.8,363.3,596.9,363.3,596.9,363.3L596.9,363.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M562.1,336c-5.3-7.3-10.2-5.7,2.9-22.7c3-3.2,4.3-1,10.3-3.8c4.1-1.5,13.7-6.5,15-3.9 c9.3,18.6,15.5,18.6-1.1,26.1c0,0-13.5,8.9-19,8.5C567.2,339.7,564.3,338.2,562.1,336L562.1,336z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M598.5,336.9c0.3,0,0.7,0,1-0.1c7.9-1.3,12.9-10.4,11.3-20.2c-1.7-9.8-9.4-16.7-17.3-15.5 c-1.9,0.4-3.8,1.2-5.4,2.4c-1.6,1.2-2.9,2.7-3.8,4.5c-0.6,1.1-1,2.4-1.1,3.7l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M582.6,325.1l-0.6-0.8c-0.2-0.3-0.4-0.7-0.4-1c-0.1-0.4-0.1-0.8,0-1.1c0.1-0.4,0.3-0.7,0.5-1 c0.2-0.3,0.6-0.5,0.9-0.7l11.4-5.6c0.7-0.4,1.6-0.5,2.4-0.3c0.8,0.2,1.5,0.6,2,1.3l0,0c0.3,0.4,0.4,0.8,0.5,1.2 c0.1,0.4,0.1,0.9-0.1,1.3c-0.1,0.4-0.3,0.8-0.6,1.2c-0.3,0.3-0.6,0.6-1,0.8l-11.4,5.6c-0.6,0.3-1.3,0.4-2,0.2 C583.6,326.1,583,325.7,582.6,325.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M583.4,324.6l-0.5-0.8c-0.2-0.3-0.4-0.7-0.4-1.1c-0.1-0.4-0.1-0.8,0-1.1c0.1-0.4,0.3-0.7,0.5-1 c0.2-0.3,0.5-0.6,0.9-0.7l11.1-5.8c0.7-0.4,1.5-0.5,2.3-0.3c0.8,0.2,1.5,0.7,1.9,1.3l0,0c0.3,0.4,0.4,0.8,0.5,1.2 c0.1,0.4,0.1,0.9,0,1.3c-0.1,0.4-0.3,0.8-0.6,1.2c-0.3,0.4-0.6,0.6-1,0.9l-11.1,5.8c-0.6,0.3-1.3,0.4-1.9,0.2 C584.3,325.5,583.7,325.1,583.4,324.6L583.4,324.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M585.6,330.7l-0.6-0.8c-0.2-0.3-0.4-0.7-0.4-1.1c-0.1-0.4-0.1-0.8,0-1.2c0.1-0.4,0.3-0.8,0.5-1.1 c0.2-0.3,0.6-0.6,0.9-0.8l9.9-4.5c0.7-0.4,1.6-0.5,2.4-0.3c0.8,0.2,1.5,0.7,2,1.4l0,0c0.3,0.4,0.4,0.8,0.5,1.3 c0.1,0.5,0.1,0.9,0,1.4c-0.1,0.5-0.3,0.9-0.6,1.3c-0.3,0.4-0.6,0.7-1.1,0.9l-9.9,4.5c-0.6,0.3-1.3,0.4-2,0.2 C586.6,331.7,586,331.3,585.6,330.7L585.6,330.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M586.5,330.2l-0.5-0.8c-0.2-0.3-0.4-0.7-0.4-1.1c-0.1-0.4-0.1-0.8,0-1.1c0.1-0.4,0.3-0.7,0.5-1 c0.2-0.3,0.5-0.6,0.9-0.7l9.6-4.2c0.7-0.4,1.5-0.5,2.3-0.3c0.8,0.2,1.5,0.7,1.9,1.3l0,0c0.3,0.4,0.4,0.8,0.5,1.2 c0.1,0.4,0.1,0.9,0,1.3c-0.1,0.4-0.3,0.8-0.6,1.2c-0.3,0.4-0.6,0.6-1,0.9l-9.6,4.2c-0.6,0.3-1.3,0.4-1.9,0.2 C587.4,331.2,586.8,330.8,586.5,330.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M581,319.5l-0.6-0.8c-0.2-0.3-0.4-0.7-0.4-1.1c-0.1-0.4-0.1-0.8,0-1.2c0.1-0.4,0.3-0.7,0.5-1 c0.2-0.3,0.6-0.6,0.9-0.7l9.9-5.9c0.7-0.4,1.6-0.5,2.4-0.3c0.8,0.2,1.5,0.7,2,1.3l0,0c0.3,0.4,0.4,0.8,0.5,1.3 c0.1,0.5,0.1,0.9,0,1.4c-0.1,0.4-0.3,0.9-0.6,1.2c-0.3,0.4-0.6,0.7-1,0.9l-9.9,5.9c-0.6,0.3-1.3,0.4-2,0.2 C582,320.5,581.4,320,581,319.5L581,319.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M581.8,318.9l-0.5-0.8c-0.2-0.3-0.4-0.7-0.4-1.1c-0.1-0.4-0.1-0.8,0-1.1c0.1-0.4,0.3-0.7,0.5-1 c0.2-0.3,0.5-0.5,0.9-0.7l9.6-5.8c0.7-0.4,1.5-0.5,2.3-0.3c0.8,0.2,1.5,0.7,1.9,1.3l0,0c0.3,0.4,0.4,0.8,0.5,1.2 c0.1,0.4,0.1,0.9,0,1.3c-0.1,0.4-0.3,0.8-0.6,1.2c-0.3,0.4-0.6,0.7-1,0.9l-9.6,5.7c-0.6,0.3-1.3,0.4-1.9,0.2 C582.7,319.8,582.2,319.4,581.8,318.9L581.8,318.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M577.3,313.9c-0.3-0.3-0.4-0.7-0.5-1.2c-0.1-0.4-0.1-0.9,0.1-1.3c0.1-0.4,0.3-0.8,0.6-1.1 c0.3-0.3,0.6-0.6,1-0.7l8.7-3.9c0.7-0.3,1.4-0.4,2.2-0.3c0.7,0.2,1.4,0.6,1.8,1.2l0,0c0.2,0.3,0.4,0.7,0.5,1.1 c0.1,0.4,0.1,0.8,0,1.2c-0.1,0.4-0.3,0.8-0.6,1.1c-0.3,0.3-0.6,0.6-1,0.7l-9.1,4.1c-0.6,0.3-1.4,0.3-2,0.2 C578.3,314.9,577.7,314.5,577.3,313.9L577.3,313.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M578.6,313.1c-0.2-0.3-0.4-0.7-0.5-1.1c-0.1-0.4-0.1-0.8,0.1-1.2c0.1-0.4,0.3-0.7,0.5-1 c0.3-0.3,0.6-0.5,0.9-0.7l7.9-3.7c0.6-0.3,1.3-0.4,2-0.2c0.7,0.2,1.3,0.6,1.7,1.1c0.2,0.3,0.4,0.7,0.4,1.1c0.1,0.4,0.1,0.8,0,1.1 c-0.1,0.4-0.3,0.7-0.5,1c-0.2,0.3-0.5,0.5-0.9,0.7L582,314c-0.6,0.3-1.2,0.3-1.9,0.2C579.5,314,579,313.7,578.6,313.1L578.6,313.1z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.3,204.3c-7.1,1.9,6.2,18.1,9,22.6c28.9,36.4,84.7,23.2,98.2-11c0.1-0.3,0.2-0.6,0.2-0.9c0-0.3-0.1-0.6-0.2-0.9 c-0.1-0.3-0.3-0.5-0.6-0.7c-0.2-0.2-0.5-0.3-0.8-0.4c-8.7-0.7-11.8-18.7-10.9-27.6c2.1-9.8-1.1-15.5-3.6-25.3 c-11-42.8-70.6-32.7-74.8,6.3c0.1,2.6,0,5.3-0.2,7.9l-0.1-0.1C343.6,184.6,340.5,201,328.3,204.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M352.1,244.1l5.7-2.2l0.9,5.9l-5.5,1.5L352.1,244.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M353.7,245.4l6.3-3.2l-1.3,6l-5.5,1.1L353.7,245.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M291.4,286.6l24.2,26.8c0,0,12.4,51.3,7.5,94.3c-1.1,9.4-5,25.3-7.1,33.6c-0.2,0.6-0.2,1.3-0.1,2 c0.1,0.7,0.4,1.3,0.8,1.8c0.4,0.5,0.9,1,1.5,1.3c0.6,0.3,1.3,0.5,1.9,0.5l113.9,1.5c0.6,0,1.3-0.1,1.8-0.4c0.6-0.3,1.1-0.6,1.5-1.1 c0.4-0.5,0.7-1,0.9-1.6c0.2-0.6,0.2-1.2,0.1-1.9c-2.4-17.9-3.2-36-2.5-54c0-7-0.3-29.8-0.3-29.8c1.1-6.3,2.6-7.6,5.5-10.9 c9-10.5,13.5-18,10-30.9l-5.8-20.1l2.1-10.7c0.2-14.7-3.9-23.8-17.9-28.2l-17.8-9.1l-61.1-0.7l-37.5,7.6 C299.8,259.4,290.7,272.5,291.4,286.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M572.3,310.2c0,0,3.6,8.4,1.5,15.7c-2,7.3-4.7,8.6-4.7,8.6l1.3-23.2L572.3,310.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M329.3,921.7h-20.1c-1.3,3.1-2.3,6.3-2.8,9.6l-8,35.2c-0.9,4.9-0.8,10,0.5,14.8l0,0c0.5,2,1.7,3.9,3.3,5.2 c1.7,1.3,3.7,2,5.8,2h9.4c1.7,0,3.3-0.4,4.7-1.2c1.4-0.8,2.6-2,3.5-3.4l0.7-1.1c2.8-5,4.4-10.6,4.6-16.3l-0.1-32.8 c0.2-4-0.3-8-1.5-11.7l0,0L329.3,921.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M407.9,245.3l-7.8-1.2l-0.2,4.6l7.8,1.3L407.9,245.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M406.4,246.2l-6.3-1l-0.2,3.7l7.8,1L406.4,246.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M449,655.4l-58.4-1.6L447.1,905c2.1,6.5,3.1,13.3,3,20.1l0,0l22.1,39.9l24.8,12.4l6.4-8.6l-27.1-51 c-2-3.6-3.3-7.6-4-11.6L449,655.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M503.3,968.8c-15.5-3.1-21.9-13.7-21.9-13.7l-21.9-32.9c-1.7-2.5-2.9-5.3-3.7-8.3l-39.7-182.1l-8.7-2.2 L447.1,905c2.1,6.5,3.1,13.3,3,20.1l22.1,39.9l20.6,10.3L503.3,968.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M528.5,984.3c0.2,0.4,0.2,0.9,0.2,1.4c0,0.5-0.2,0.9-0.5,1.3c-0.3,0.4-0.6,0.7-1.1,1 c-0.4,0.2-0.9,0.4-1.4,0.4h-31.3c-3.8,0-7.6-0.8-11.1-2.5c-3.5-1.6-6.5-4-9-7l-17.2-21c-0.3-0.4-0.7-0.6-1.1-0.8 c-0.5-0.1-0.9-0.1-1.4,0c-0.5,0.1-0.8,0.4-1.1,0.8c-0.3,0.4-0.4,0.8-0.4,1.3l-0.9,29.2H449l-4.1-28.4c-1.8-11.9,0-24.1,5.1-35l0,0 l28.3,34.2c3,3.7,6.9,6.4,11.3,8.1c4.4,1.7,9.2,2.1,13.8,1.4l17.6,8C524.2,978.3,526.9,981,528.5,984.3L528.5,984.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M353.6,654.3l-4,44.2l-0.2,2.4l-18.7,206.1c-1.4,11.8-2,23.7-1.8,35.7l0.2,14.2c-0.1,3-1.4,5.9-3.5,7.9 c-2.2,2.1-5.1,3.2-8.1,3.2h-1.9c-2.4,0-4.8-0.8-6.7-2.2c-1.7-1.2-3.1-2.9-3.9-4.9c-0.8-1.9-1.1-4.1-0.9-6.2l3.3-16.9 c0.7-3.7,1.2-7.4,1.5-11.2c0.2-1.7,0.3-3.4,0.3-5.1c0.1-3.2,0.1-6.5,0-9.7l-7.7-220.7l-1.3-37.6L353.6,654.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M307,712.1l6.4,185.7c0.6,16.6-0.4,33.2-2.9,49.7l-0.9,6c-0.5,3.5-0.8,7.1-0.8,10.7v1.6 c-1.7-1.2-3.1-2.9-3.9-4.9c-0.8-1.9-1.1-4.1-0.9-6.2l3.3-16.9c0.7-3.7,1.2-7.4,1.5-11.2c1.3-2.8,1.5-4.7,0.3-5.1 c0.1-3.2,0.1-6.5,0-9.7l-7.7-220.7l48.3,7.1l8.6,1.3l-8.8,1.1l-37,4.6c-1.6,0.3-3,1.1-4,2.3C307.4,709,306.9,710.5,307,712.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M574.3,318.1c0,0,10.5,2.5,13.4-3c3.1-5.8-5.9-5.1-8.5-5.5c-2.6-0.4-0.9,3.3-5.3,4.2L574.3,318.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M317.1,445.2l-0.9,3.6c-14.3,56.7-24,116.6-23.3,175.1l5.7,117.4l161.2-1.5l-23.6-292.9L317.1,445.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M578.9,310L578.9,310c-8-3.2-15.5,1.3-17.6,9.6l-0.5,2c-1.6,7.5,1.4,12.3,4.4,13.4c2.2,0.8,5.2,0.4,6.9-6.7 c1.1-3.6,1.3-7.4,0.8-11.2c4.4,0.7,11.2,1.1,13.6-2.1C590.7,309.5,581.2,311,578.9,310z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M313.8,570.9c4-84.2,17.7-123.6,17.7-123.6l-4.3-2l-10.1-0.1l-0.9,3.6c-14.3,56.7-24,116.6-23.3,175.1 l6.8,117.4h21.9l-6.6-87.2C312.9,626.4,312.5,598.6,313.8,570.9L313.8,570.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M482.4,345.9l78.2-26.6l10.8,20.7l-94.7,45c-1.9,0.9-4.1,1.4-6.2,1.4c-2.1,0-4.3-0.4-6.3-1.2 c-2-0.8-3.8-2.1-5.3-3.6c-1.5-1.6-2.6-3.4-3.3-5.4l-8.3-25.3L482.4,345.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M450.4,360.3l-38.9-111l22.9,5.6c10.6,2.7,20.7,5.4,24.9,15.9l23,75.1L450.4,360.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M458.3,357.1l4.1,13.3c0,0,3.6,13.7,18.7,12.5l-4.4,2c-1.9,0.9-4.1,1.4-6.2,1.4c-2.1,0-4.3-0.4-6.3-1.2 c-2-0.8-3.8-2.1-5.3-3.6c-1.5-1.6-2.6-3.4-3.3-5.4l-5.1-15.9L458.3,357.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M448.5,354.9l2.1,5.3l7.3-3.3l0.3-0.2c0,0-7.2-13.7-4.6-18.9c1.5-3.7,2.2-7.7,2-11.7c-0.2-7.3-2-14.5-5.3-21 c-2.9-6-7.3-14.3-10.8-19l7.6,22.4c1.1,3,1.9,6.1,2.6,9.3c2.2,10,1.9,17.8-5.3,26.6L448.5,354.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M340.8,251.7l20.1,14.9c2,1.7,4.6,2.5,7.2,2.4l27-0.3c1.4-0.1,2.8-0.4,4.1-1c1.3-0.6,2.4-1.5,3.4-2.6 l12.6-14.6l-9.8-1.1l-55.8,0.6L340.8,251.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M346.5,250.4l8.2-3.1c0.8-0.2,1.6-0.7,2.2-1.3c0.6-0.7,0.9-1.5,0.9-2.4l2.5-45.4l38.2-4.5l1.7,51.4 c0,0.9,0.4,1.7,0.9,2.4c0.6,0.7,1.3,1.2,2.2,1.4l5.5,0.8l-10.4,11.4c-0.9,1-2,1.8-3.2,2.4c-1.2,0.6-2.5,0.9-3.9,0.9l-21.8-0.4 c-2.4,0.1-4.7-0.7-6.6-2.2L346.5,250.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M414.5,206.4l1.2-34.2c0.1-1.5-0.2-3-0.7-4.4c-0.5-1.4-1.3-2.7-2.3-3.8c-1-1.1-2.3-2-3.6-2.6 c-1.4-0.6-2.8-1-4.3-1l-34.3-1.1c-1.2,0-2.3,0.1-3.4,0.5c-1.1,0.4-2.1,1-2.9,1.8c-0.8,0.8-1.5,1.7-2,2.8c-0.5,1.1-0.7,2.2-0.8,3.3 l-1.3,36.8c-0.2,7,2.3,13.7,7,18.8c4.7,5.1,11.3,8.1,18.3,8.4l2.1,0.1c3.5,0.1,6.9-0.5,10.1-1.7c3.2-1.2,6.2-3.1,8.7-5.4 c2.5-2.4,4.5-5.2,6-8.3C413.6,213.3,414.4,209.9,414.5,206.4L414.5,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.8,195c0-0.6,0.2-1.1,0.5-1.6c0.3-0.5,0.8-0.8,1.3-1c0.5-0.2,1.1-0.3,1.6-0.2c0.5,0.1,1.1,0.4,1.5,0.8 c0.4,0.4,0.7,0.9,0.8,1.5c0.1,0.6,0.1,1.1-0.2,1.6c-0.2,0.5-0.6,1-1.1,1.3c-0.5,0.3-1,0.5-1.6,0.5c-0.7,0-1.5-0.3-2-0.8 C384.1,196.4,383.8,195.7,383.8,195z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M387.1,196.2c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.2,0.1-0.2c0.1-0.1,0.1-0.1,0.2-0.2c0.1,0,0.2-0.1,0.2-0.1 c0.1,0,0.2,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.2c0.1,0.1,0.1,0.1,0.1,0.2c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.3-0.2,0.4 c-0.1,0.1-0.2,0.1-0.4,0.1s-0.3,0-0.4-0.1C387.2,196.5,387.1,196.4,387.1,196.2L387.1,196.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.7,197c0-0.6,0.2-1.1,0.5-1.6c0.3-0.5,0.8-0.8,1.3-1c0.5-0.2,1.1-0.3,1.6-0.2c0.5,0.1,1.1,0.4,1.4,0.8 c0.4,0.4,0.7,0.9,0.8,1.4c0.1,0.5,0.1,1.1-0.2,1.6c-0.2,0.5-0.6,1-1,1.3c-0.5,0.3-1,0.5-1.6,0.5c-0.8,0-1.5-0.3-2-0.8 C406,198.5,405.7,197.8,405.7,197L405.7,197z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M409.2,198.2c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2-0.1,0.3,0c0.1,0,0.2,0.1,0.3,0.2 c0.1,0.1,0.1,0.2,0.2,0.3c0,0.1,0,0.2,0,0.3c0,0.1-0.1,0.2-0.2,0.3c-0.1,0.1-0.2,0.1-0.3,0.1c-0.2,0-0.3-0.1-0.4-0.2 S409.2,198.3,409.2,198.2L409.2,198.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.6,174.3l1.1,0.6c0.8,3.8,1.7,7.6,2.9,11.3c1,3.4,2.1,6.5,2.8,9.2c0.4,1.5,2.5-1.6,4.5-4.4c0.4-0.5,0.7-1,1.1-1.4 c0.5-0.8,1.2-1.5,2-2c0.1,0,0.5,0.4,1,1.1v0.1c0.1,0.2,0.2,0.4,0.4,0.6c0.5,0.8,1.1,1.8,1.5,2.6c0.1,0.3,0.3,0.5,0.6,0.7 c0.3,0.2,0.6,0.2,0.9,0.2c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.4-0.4,0.5-0.7c1.8-4.5,2.7-9.3,2.9-14.1l0.2-4.4 c2.7-0.2,5.3-1.1,7.6-2.5c2.3-1.4,4.2-3.3,5.7-5.6c0.3-0.4,0.6-0.9,0.8-1.3l0.1,0.1c8.6,11.1,24.4,11.2,30.9,10.7 c0.5,0,1,0.1,1.5,0.3c0.4,0.3,0.8,0.6,1,1.1c0.2,0.4,0.3,0.8,0.2,1.2l-0.3,8.8v1.5l-0.2,6.1c1.3-1.2,2.5-2.4,3.6-3.8 c0.3-0.4,0.6-0.8,0.9-1.2c0.3-0.4,0.5-0.7,0.8-1.1l0.7,2.5l1.2,1.2c-0.1-0.6,0.9-2.3,0.8-2.9c-0.1-1-0.1-2,0-3l0,0 c0-0.2,0-0.4,0-0.7c0-1.1,0.2-2.2,0.5-3.2l0.1-0.3c0.3-0.7,0.6-1.4,0.8-2.2c0.5-1.6,0.9-3.3,1-5c0.9-8.8-3.6-12.5-6-13.8 c-0.4-0.2-0.8-0.6-1-1c-0.2-0.4-0.4-0.9-0.4-1.4c-0.6-24.6-36.6-34.5-57.5-19.8c-10.7,7.5-16.2,17.4-16,27.8c0,0,0,0.2,0,0.6 C344.9,169.2,344.8,171.7,344.6,174.3L344.6,174.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M403,461.8c0,0.4,0.2,0.8,0.5,1.1c0.3,0.3,0.7,0.5,1.1,0.5l32.5,0.4c0.6,0,1.3-0.1,1.8-0.4 c0.6-0.3,1.1-0.6,1.5-1.1c0.4-0.5,0.7-1,0.9-1.6c0.2-0.6,0.2-1.3,0.1-1.9c-1.3-9-6.6-44.7-5.6-69.5c0-7,1.2-29.8,1.2-29.8 c1.1-6.3,1.1-7.6,3.9-10.9c9-10.5,13.5-18,10-30.9l-5.8-20.1l2.1-10.7c0.2-14.7,5.5-26.3-8.5-30.7l-21.5-6.8l-1.7-0.5l-7.7-3.5 l-4.9,95.1L403,461.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M363.2,206.2l-1.7-13.6c-2.2-12.5-17.6-10-14.9,2.4c2.7,12.4,15.3,11.3,15.3,11.3H363.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M350.1,189.6c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.2-0.1,0.3-0.1 c0.3-0.3,0.7-0.5,1.2-0.7c0.4-0.1,0.9-0.2,1.3-0.1c0.4,0.1,0.8,0.3,1.2,0.6c0.3,0.3,0.6,0.6,0.8,1c0.7,1.2,1.1,2.6,1.2,4l0.1,1.5 c0,1.1,1.8,0.8,1.7-0.2l-0.1-1.4c-0.1-1.7-0.6-3.4-1.5-4.9c-0.3-0.6-0.7-1.1-1.3-1.6c-0.5-0.4-1.2-0.7-1.8-0.9 c-0.7-0.1-1.4,0-2,0.1c-0.7,0.2-1.3,0.5-1.8,0.9c-0.1,0.2-0.2,0.4-0.3,0.6C350,189.2,350,189.4,350.1,189.6L350.1,189.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M352.1,244.1l-8.1,4.5l-0.9,0.3l-30,7.4c-13.3,3.1-22.4,16.2-21.8,30.2l24.2,26.8c0,0,7.7,51.3,2.9,94.3 c-1.1,9.4-5,40.8-7.1,49.1c-0.2,0.6-0.2,1.3-0.1,2c0.1,0.7,0.4,1.3,0.8,1.8c0.4,0.5,0.9,1,1.5,1.3c0.6,0.3,1.3,0.5,1.9,0.5 l53.7,0.5c0.4,0,0.8-0.2,1.1-0.5c0.3-0.3,0.5-0.7,0.5-1.1l1.5-120.9L352.1,244.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M425.8,429h-51.7c-0.7,0-1.3-0.2-1.8-0.7c-0.5-0.4-0.8-1-0.8-1.7l-6.9-70.9c0-0.4,0-0.7,0.1-1.1 c0.1-0.3,0.3-0.7,0.5-0.9c0.2-0.3,0.5-0.5,0.9-0.6c0.3-0.1,0.7-0.2,1.1-0.2h65.5c0.4,0,0.7,0.1,1.1,0.2c0.3,0.1,0.6,0.4,0.9,0.6 c0.2,0.3,0.4,0.6,0.5,0.9c0.1,0.3,0.2,0.7,0.1,1.1l-6.9,70.9c-0.1,0.6-0.4,1.3-0.8,1.7C427.1,428.7,426.4,429,425.8,429L425.8,429z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.8,429h-51.7c-0.7,0-1.3-0.2-1.8-0.7c-0.5-0.4-0.8-1-0.8-1.7l-6.9-70.9c0-0.4,0-0.7,0.1-1.1c0.1-0.3,0.3-0.7,0.5-0.9 c0.2-0.3,0.5-0.5,0.9-0.6c0.3-0.1,0.7-0.2,1.1-0.2h65.5c0.4,0,0.7,0.1,1.1,0.2c0.3,0.1,0.6,0.4,0.9,0.6c0.2,0.3,0.4,0.6,0.5,0.9 c0.1,0.3,0.2,0.7,0.1,1.1l-6.9,70.9c-0.1,0.6-0.4,1.3-0.8,1.7C427.1,428.7,426.4,429,425.8,429L425.8,429z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M425.8,431.4h-51.7c-0.6,0-1.3-0.2-1.8-0.7c-0.5-0.4-0.8-1-0.9-1.7l-6.9-70.9c0-0.4,0-0.7,0.1-1.1 c0.1-0.3,0.3-0.7,0.5-0.9c0.2-0.3,0.5-0.5,0.9-0.6s0.7-0.2,1.1-0.2h65.5c0.4,0,0.7,0.1,1.1,0.2c0.3,0.1,0.6,0.4,0.9,0.6 c0.2,0.3,0.4,0.6,0.5,0.9c0.1,0.3,0.2,0.7,0.1,1.1l-6.9,70.9c-0.1,0.6-0.4,1.2-0.9,1.7C427.1,431.2,426.4,431.4,425.8,431.4 L425.8,431.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M426.3,366.5c0,0.6-0.2,1.3-0.5,1.8c-0.4,0.5-0.9,0.9-1.4,1.2c-0.6,0.2-1.2,0.3-1.9,0.2 c-0.6-0.1-1.2-0.4-1.6-0.9c-0.5-0.5-0.8-1-0.9-1.6c-0.1-0.6-0.1-1.3,0.2-1.9c0.2-0.6,0.7-1.1,1.2-1.4c0.5-0.4,1.2-0.5,1.8-0.5 c0.9,0,1.7,0.3,2.3,0.9C426,364.8,426.3,365.6,426.3,366.5L426.3,366.5z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M423.1,363.2c0.8,0,1.6,0.3,2.2,0.9c0.6,0.6,1,1.4,1,2.2v-0.1c0-0.4,0-0.9-0.2-1.3c-0.1-0.4-0.4-0.8-0.7-1.1 c-0.3-0.3-0.7-0.6-1.1-0.8c-0.4-0.2-0.8-0.3-1.3-0.3s-0.9,0.1-1.3,0.3c-0.4,0.2-0.8,0.4-1.1,0.8c-0.3,0.3-0.5,0.7-0.7,1.1 c-0.1,0.4-0.2,0.9-0.2,1.3v0.1c0-0.8,0.4-1.6,1-2.2C421.5,363.6,422.3,363.2,423.1,363.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M425.1,366.5c0,0.4-0.1,0.8-0.3,1.1c-0.2,0.3-0.5,0.6-0.9,0.7c-0.4,0.2-0.8,0.2-1.2,0.1 c-0.4-0.1-0.7-0.3-1-0.5c-0.3-0.3-0.5-0.6-0.5-1c-0.1-0.4,0-0.8,0.1-1.2c0.2-0.4,0.4-0.7,0.7-0.9c0.3-0.2,0.7-0.3,1.1-0.3 c0.3,0,0.5,0,0.8,0.1c0.2,0.1,0.5,0.2,0.6,0.4c0.2,0.2,0.3,0.4,0.4,0.6C425.1,365.9,425.1,366.2,425.1,366.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M423.1,367.9c-0.5,0-0.9-0.2-1.3-0.5c-0.4-0.3-0.6-0.8-0.7-1.2c0,0.1,0,0.2,0,0.3c0,0.5,0.3,1,0.6,1.3 c0.4,0.3,0.8,0.5,1.3,0.5c0.5,0,1-0.2,1.3-0.5c0.4-0.3,0.6-0.8,0.6-1.3c0-0.1,0-0.2,0-0.3c-0.1,0.5-0.3,0.9-0.7,1.2 C424.1,367.8,423.6,367.9,423.1,367.9L423.1,367.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M374.2,194.4c0,0.7,0.1,1.4,0.2,2.1c0.5,2.8,2.1,5.3,4.4,7c2.3,1.7,5.1,2.5,7.9,2.2c2.8-0.3,5.4-1.6,7.4-3.7 c1.9-2.1,3-4.8,3-7.7c0-0.2,0-0.3,0-0.5c0-1.1-0.3-2.2-0.7-3.3c1.9-0.5,3.9-0.3,5.7,0.4c-1.1,1.8-1.7,3.9-1.7,6 c0,1.9,0.5,3.7,1.4,5.4c0.9,1.7,2.2,3.1,3.7,4.1c1.6,1,3.4,1.7,5.2,1.9c1.9,0.2,3.8-0.1,5.5-0.8c1.7-0.7,3.3-1.9,4.4-3.3 c1.2-1.5,2-3.2,2.3-5c0.4-1.8,0.3-3.7-0.3-5.5c-0.6-1.8-1.5-3.4-2.9-4.7c-1.2-1.2-2.6-2.1-4.2-2.6l-0.3-0.1 c-1.1-0.4-2.3-0.6-3.5-0.6c-1.7,0-3.4,0.4-4.9,1.1c-1.5,0.7-2.9,1.8-3.9,3.2c-2.2-1-4.7-1.2-7-0.5c-1.1-2.3-3-4.2-5.4-5.3 c-2.3-1.1-5-1.4-7.5-0.8c-2.5,0.6-4.7,2-6.3,4C375.1,189.3,374.2,191.8,374.2,194.4L374.2,194.4z M411.7,187c1.2,0,2.4,0.2,3.5,0.6 l0.3,0.1c1.3,0.5,2.4,1.3,3.4,2.3c1.2,1.2,2.1,2.7,2.5,4.4c0.4,1.7,0.4,3.4,0,5c-0.4,1.7-1.3,3.2-2.5,4.4c-1.2,1.2-2.7,2.1-4.3,2.6 c-1.4,0.4-2.8,0.5-4.2,0.3c-1.4-0.2-2.8-0.7-4-1.5c-1.2-0.8-2.2-1.8-3-3c-0.8-1.2-1.3-2.6-1.5-4c-0.2-1.4-0.1-2.9,0.3-4.2 c0.4-1.4,1.1-2.6,2-3.7c0.9-1.1,2.1-1.9,3.4-2.5C408.9,187.3,410.3,187,411.7,187L411.7,187z M375.9,196.3c-0.1-0.6-0.2-1.3-0.2-2 c0-2.6,1-5.2,2.8-7.1c1.8-1.9,4.3-3,7-3c2.6,0,5.2,1,7.1,2.8c1.9,1.8,3,4.3,3,7c0,0.1,0,0.2,0,0.3c0,2.5-0.9,4.9-2.5,6.7 c-1.7,1.8-3.9,3-6.4,3.2c-2.5,0.2-4.9-0.4-6.9-1.9C377.7,200.9,376.3,198.8,375.9,196.3L375.9,196.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M329.9,349.1c-2-14.5-1.3-27.5-2.8-36.5c-0.1-0.5-0.3-0.9-0.6-1.2c-0.3-0.3-0.8-0.5-1.2-0.5 c-0.5,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.6-0.8,1.1l-4.9,13.5l-0.2,1.3c3.3,17.8,3.7,52,0.4,82.1c-1.1,9.4-5,39.2-7.1,47.6 c-0.2,0.6-0.2,1.3-0.1,2c0.1,0.7,0.4,1.3,0.8,1.8c0.4,0.5,0.9,1,1.5,1.3c0.6,0.3,1.3,0.5,1.9,0.5h4.6c2.2-5.4,3.8-11.1,4.9-16.8 C329.9,411,333.5,375.7,329.9,349.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M298.3,374l46.4-114l-20-6.2c-22.3,3.9-25.2,5.6-34.8,26.8l-27.1,82.6L298.3,374z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M262.8,363.2l-6.4,19.5c-0.7,2.2-0.9,4.5-0.7,6.8c0.3,2.3,1.1,4.5,2.3,6.4c1.2,1.9,2.8,3.6,4.8,4.9 c1.9,1.2,4.1,2.1,6.4,2.4l98.8,15.3l-0.5-20.2l-69.2-24.1L262.8,363.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M359.3,214.6l4.2-8.4H360L359.3,214.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M399.9,238c-1.9,0.3-3.8,0.3-5.6,0.2c-4.8-0.3-9.3-2.2-12.9-5.5c-4-0.7-7.8-2.3-11.2-4.6 c-0.2-0.1-0.3-0.3-0.3-0.4c0-0.2,0-0.4,0.1-0.5c0.1-0.2,0.3-0.3,0.4-0.3c0.2,0,0.4,0,0.5,0.1c2.6,1.8,5.5,3.1,8.6,3.9 c0.2,0.1,0.5,0.1,0.7,0.2c0.6,0.2,1.2,0.3,1.7,0.4h0.3c0.4,0.1,0.8,0.1,1.2,0.2c1,0.1,2,0.2,3,0.2c4.5,0.3,9.1-0.6,13.2-2.5 L399.9,238z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M423.9,181.2c0.3-0.7,0.6-1.4,0.8-2.2C424.3,179.7,424.1,180.4,423.9,181.2L423.9,181.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M423.2,188.4c-0.1-1-0.1-2,0-3l0,0c0-0.2,0-0.4,0-0.7c0,0.5,0,1,0,1.5C423.2,187,423.2,187.7,423.2,188.4 L423.2,188.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M343.1,183.6c0.8-3,1.4-6.1,1.5-9.3l-0.1-0.1C344.2,177.4,343.7,180.5,343.1,183.6L343.1,183.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M401.6,205.4c0-0.9-0.4-1.8-1-2.4c-0.6-0.6-1.5-1-2.4-1c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.3,0.4-0.3,0.6 c0,0.2,0.1,0.5,0.3,0.6c0.2,0.2,0.4,0.3,0.6,0.3c0.5,0,0.9,0.2,1.2,0.5c0.3,0.3,0.5,0.8,0.5,1.2c0,0.5-0.2,0.9-0.5,1.2 c-0.3,0.3-0.8,0.5-1.2,0.5h-3.9c-0.2,0-0.5,0.1-0.6,0.3c-0.2,0.2-0.3,0.4-0.3,0.6c0,0.2,0.1,0.5,0.3,0.6c0.2,0.2,0.4,0.3,0.6,0.3 h3.9c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.8-0.5,1.1-0.8c0.3-0.3,0.6-0.7,0.7-1.2C401.5,206.3,401.6,205.8,401.6,205.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.2,363.4l-0.4-0.2l-0.6,1.8C262.8,364,263.2,363.4,263.2,363.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M591.7,321c0,0-0.1,0.1-0.1,0.1C591.6,321.1,591.6,321.1,591.7,321L591.7,321z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M277.6,396.9c-16.3-3.1-19.4-14.5-18.7-21.6l-2.4,7.4c-0.7,2.2-0.9,4.5-0.7,6.8c0.3,2.3,1.1,4.5,2.3,6.4 c1.2,1.9,2.8,3.6,4.8,4.9c1.9,1.2,4.1,2.1,6.4,2.4l98.8,15.3l-1.4-4.4L277.6,396.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M365.5,384.6c-1.4,4.1-2.1,8.5-2,12.8h-1.5l-3,6.8c-0.7,1.7-0.9,3.5-0.5,5.3c0.4,1.8,1.3,3.4,2.6,4.6l1.8,1.5 c3.5,3.2,7.9,4.9,12.6,5c3.1,0,6.2,0.1,9.3,0.4c2.9,0.5,5.8,0.7,8.8,0.6c1.8-0.2,21.2,1.7,23.5,1.7c2.3,0,3.5-3.1,1.5-4.1 c-1.2-0.6-20.2-2.8-26.4-3.8c-1.3-0.2,0-1.5,0-1.5s20.6,0,22.8-0.6c2.2-0.6,2.5-4.2-1.6-5c-3.3-0.7-26.1-0.3-27.1-3 c-1.1-2.7,10.7-5.4,13.3-6.7c2.6-1.4,5.3-2,3.8-5.2c-1-2-18.4,3-21.4,3.3c-3,0.3-7.4-2.7-9.7-5.3c-1.2-1.4-1.5-4.8-1.5-7.6 c0-2.2-0.9-5.6-2.6-7.2c-0.1-0.1-0.2-0.2-0.4-0.2c-0.1,0-0.3,0-0.4,0c-0.1,0-0.3,0.1-0.4,0.2c-0.1,0.1-0.2,0.2-0.2,0.4L365.5,384.6 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M358.9,411.1c0.5,1.2,1.2,2.2,2.1,3.1l1.8,1.5c3.5,3.2,7.9,4.9,12.6,5c4.1,0,8.7,0,9.3,0.4 c1,0.7,6.9,0.8,8.8,0.6c1.8-0.2,21.2,1.7,23.5,1.7c0.2,0,0.4,0,0.6,0c0.2-0.1,0.4-0.2,0.5-0.3c0.2-0.1,0.3-0.3,0.4-0.5 c0.1-0.2,0.2-0.4,0.2-0.6c-2,0.3-4.1,0.2-6.1-0.2l-28.5-3.1C369.8,420.4,359.1,411.3,358.9,411.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M417.9,250.5l3.6,25.3l-10.4,0.5l11.1,7.9c0,0-6.2,28.5-18.2,51c0,0,8.5-25,15.9-49.8l-10.8-9.5l10.5-1 l-3.1-25.2L417.9,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M342.2,249.5l-1.9,25.5l10.4-0.2l-10.6,8.6c0,0,16,32.5,29.5,54.1c0,0-17.6-33.1-27.1-53l10.2-10.2l-10.5-0.3 l1.4-25.4L342.2,249.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M482.4,345.9l-5.8,2.6l4.5-6.9L482.4,345.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.3,374l-7-2.3l8.8-2.1L298.3,374z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M331.3,385.5l32.1,11.9l0-2.5l-32.2-11.7V385.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M387.7,213.9c-0.4,0-0.6,0.3-0.5,0.7c0.4,1.5,1.2,2.8,2.3,3.8s2.6,1.6,4.1,1.8c1.5,0.2,3.1-0.1,4.4-0.9 c1.3-0.7,2.4-1.9,3.1-3.2c0-0.1,0.1-0.2,0.1-0.2c0-0.1,0-0.2-0.1-0.2c0-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.1-0.1-0.2-0.1L387.7,213.9z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M355.8,209.1c0.4,0,0.7-0.1,1.1-0.3c0.3-0.2,0.6-0.4,0.9-0.7c0.2-0.3,0.4-0.6,0.5-1c0.1-0.4,0.2-0.7,0.1-1.1 c0-0.7-0.2-1.3-0.5-1.8c-0.4-0.5-0.9-0.9-1.5-1.1c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.2,0.2 c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,0.1,0.2,0.2,0.2c0.1,0.1,0.2,0.1,0.3,0.1 c0.3,0.1,0.6,0.3,0.8,0.6c0.2,0.3,0.3,0.6,0.2,0.9c0,0.4-0.1,0.7-0.3,1c-0.2,0.3-0.6,0.5-0.9,0.6c-0.7,0-1.2-0.7-1.2-1.6 c0-0.1,0-0.2,0-0.4c0-0.1,0-0.2,0-0.3c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.1-0.1-0.2-0.2c-0.1-0.1-0.2-0.1-0.3-0.1 c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0.1-0.1,0.1-0.2,0.2c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.2,0,0.4,0,0.6 c0,0.4,0,0.8,0.1,1.1s0.3,0.7,0.5,1c0.2,0.3,0.5,0.5,0.9,0.7C355,209,355.4,209.1,355.8,209.1L355.8,209.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M182.6,854.1c-0.3-1.9-0.5-3.8-0.5-5.7c0-21.5,20.2-39,45.1-39c24.9,0,45.1,17.5,45.1,39 c0,1.9-0.2,3.8-0.5,5.7H182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M182.6,854.4c-0.3-1.9-0.5-3.8-0.5-5.7c0-21.5,20.2-39,45.1-39c24.9,0,45.1,17.5,45.1,39 c0,1.9-0.2,3.8-0.5,5.7H182.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M131.6,844.5c-0.3-2.7-0.5-5.3-0.5-8c0-30.4,20.2-55,45.1-55c24.9,0,45.1,24.6,45.1,55c0,2.7-0.2,5.4-0.5,8 H131.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M148.1,878.2c0.3-1.9,0.5-3.8,0.5-5.7c0-21.5-20.2-39-45.1-39s-45.1,17.5-45.1,39c0,1.9,0.2,3.8,0.5,5.7 H148.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M220.4,878.2c0.4-2.7,0.6-5.3,0.6-8c0-30.4-25.6-55-57.2-55c-31.6,0-57.2,24.6-57.2,55c0,2.7,0.2,5.4,0.6,8 H220.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M220.4,878.2c0.4-2.7,0.6-5.3,0.6-8c0-30.4-25.6-55-57.2-55c-31.6,0-57.2,24.6-57.2,55c0,2.7,0.2,5.4,0.6,8 H220.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M176.4,815.2c7.6,0.1,15.2,1.9,22,5.4c6.8,3.5,12.7,8.5,17.2,14.7c4.9-1.2,9.9-1.7,15-1.7 c28,0,50.7,17.5,50.7,39c0,1.9-0.2,3.8-0.5,5.7H126.2c-0.4-2.7-0.5-5.3-0.5-8C125.7,839.8,148.4,815.2,176.4,815.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M196.4,872.6c-4.9-5.5-10.5-11-14.9-17c-1-1.3-6-9.9-2-8.9c4,0.9,7.6,7.4,9.4,10.5c1.8,3.1,3.6,6.3,5.3,9.5 c0.8,1.4,1.5,2.8,2.1,4.3C196.2,871.2,196.7,872.9,196.4,872.6C192.6,868.5,197,873.3,196.4,872.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M217.1,919.3c-0.1-2-0.5-4-1.1-5.9c-1.3-3.9-3.2-7.6-5.7-10.8c-5.2-7-12.4-13.5-20.8-16.3 c-1.9-0.7-4-1.1-6-1.3c-1,0-3.9-0.4-4.7,0.4s0.2,0.7,1,0.9c1.5,0.6,2.9,1.3,4.3,2.2c12.8,7.3,28,15.8,31.8,30.9L217.1,919.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M217.1,919.3c-0.1-2-0.5-4-1.1-5.9c-1.3-3.9-3.2-7.6-5.7-10.8c-5.2-7-12.4-13.5-20.8-16.3 c-1.9-0.7-4-1.1-6-1.3c-1,0-3.9-0.4-4.7,0.4s0.2,0.7,1,0.9c1.5,0.6,2.9,1.3,4.3,2.2c12.8,7.3,28,15.8,31.8,30.9L217.1,919.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.9,919.2c-1.2-11.7-5-22.8-9.2-33.6c-1.9-5-3.8-10-6.1-14.7c-2.8-5.8-6.2-11.4-9.5-16.9 c-1.6-2.6-3.2-5.2-4.9-7.7c-0.8-1.1-1.6-2.2-2.5-3.3c-0.3-0.4-1.9-1.8-1.9-2.3c-0.1-0.8,0.7-0.2,1.1,0c1.1,0.6,2.1,1.3,3,2.1 c2.3,1.9,4.4,4,6.4,6.3c4.1,4.8,7.6,10.2,10.2,16c2.4,5.8,4.6,11.6,6.4,17.6c2.4,6.9,4.3,13.9,5.7,21c0.6,3.2,1.1,6.4,1.4,9.6 c0.1,1.4,0.2,2.7,0.2,4.1c0,0.3,0.2,1.3,0,1.5C220.3,919.1,219.9,919.9,219.9,919.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M219.9,919.2c-1.2-11.7-5-22.8-9.2-33.6c-1.9-5-3.8-10-6.1-14.7c-2.8-5.8-6.2-11.4-9.5-16.9 c-1.6-2.6-3.2-5.2-4.9-7.7c-0.8-1.1-1.6-2.2-2.5-3.3c-0.3-0.4-1.9-1.8-1.9-2.3c-0.1-0.8,0.7-0.2,1.1,0c1.1,0.6,2.1,1.3,3,2.1 c2.3,1.9,4.4,4,6.4,6.3c4.1,4.8,7.6,10.2,10.2,16c2.4,5.8,4.6,11.6,6.4,17.6c2.4,6.9,4.3,13.9,5.7,21c0.6,3.2,1.1,6.4,1.4,9.6 c0.1,1.4,0.2,2.7,0.2,4.1c0,0.3,0.2,1.3,0,1.5C220.3,919.1,219.9,919.9,219.9,919.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M219.5,919.3l1,0c-0.1-0.6-0.2-1.3-0.2-1.8c-0.2-2.8-0.6-5.6-1.2-8.4c-1.2-6.1-3.2-11.9-6-17.4 c-5.2-10.1-12.7-19.2-23.1-24.3c-1-0.5-12.4-5.1-12.7-3.5c-0.2,0.7,3.8,2.7,4.4,3.1c2,1.4,4,2.8,6,4.3c8.7,6.6,17,13.8,22.7,23.3 C214.8,902.2,217.9,910.6,219.5,919.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M224.8,919.1l0.5,0c0-0.7,0-1.5-0.1-2.2c-0.1-2.1-0.2-4.1-0.3-6.2c-0.3-4.7-0.7-9.3-1.2-14 c-1.1-8.5-2.3-17-5.5-24.9c-0.7-1.8-1.6-3.6-2.5-5.4c-0.2-0.3-1.4-3-1.8-2.4c-0.1,0.2,0.2,1.2,0.2,1.4c0.1,0.8,0.3,1.6,0.5,2.3 c0.4,1.9,0.8,3.7,1.2,5.6c1.8,8.4,4.2,16.6,5.8,24.9C222.8,905.2,223.8,912.1,224.8,919.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M224.8,919.1l0.5,0c0-0.7,0-1.5-0.1-2.2c-0.1-2.1-0.2-4.1-0.3-6.2c-0.3-4.7-0.7-9.3-1.2-14 c-1.1-8.5-2.3-17-5.5-24.9c-0.7-1.8-1.6-3.6-2.5-5.4c-0.2-0.3-1.4-3-1.8-2.4c-0.1,0.2,0.2,1.2,0.2,1.4c0.1,0.8,0.3,1.6,0.5,2.3 c0.4,1.9,0.8,3.7,1.2,5.6c1.8,8.4,4.2,16.6,5.8,24.9C222.8,905.2,223.8,912.1,224.8,919.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M240.5,895c-0.7-4.8-0.7-9.8,0-14.6c0.3-2.9,0.9-5.7,1.8-8.4c1-2.6,2.2-5,3.7-7.3c0.6-0.9,1.2-1.9,1.7-2.8 c0.2-0.3,1-2.3,1.3-2.3c1-0.1,0,4.6-0.2,5.3c-0.8,2.6-1.8,5.1-3.1,7.5c-1.3,2.5-2.3,5.2-2.9,8c-0.7,2.9-1.3,5.8-1.7,8.8 c-0.2,1.3-0.3,2.6-0.3,4c0,0.5,0,1-0.1,1.5C240.9,894.4,240.7,895.9,240.5,895z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240.5,895c-0.7-4.8-0.7-9.8,0-14.6c0.3-2.9,0.9-5.7,1.8-8.4c1-2.6,2.2-5,3.7-7.3c0.6-0.9,1.2-1.9,1.7-2.8 c0.2-0.3,1-2.3,1.3-2.3c1-0.1,0,4.6-0.2,5.3c-0.8,2.6-1.8,5.1-3.1,7.5c-1.3,2.5-2.3,5.2-2.9,8c-0.7,2.9-1.3,5.8-1.7,8.8 c-0.2,1.3-0.3,2.6-0.3,4c0,0.5,0,1-0.1,1.5C240.9,894.4,240.7,895.9,240.5,895z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M236.5,856.4c0.3,2.2,0.5,4.4,0.8,6.6c1.1,9.8,1.8,19.6,2,29.5c0.2,8,0.3,18.4,0.8,26.7l0.8,0 c-0.1-1.5-0.1-3.3-0.1-4c0.1-2.4,0-5.8,0.1-8.3c0.2-5.5,0.6-11,0.8-16.5c0.3-9.6,0.6-19.2-1.8-28.5c-0.5-2.1-1.2-4.1-1.9-6.1 c-0.4-1-0.8-1.9-1.2-2.8c-0.1-0.2-0.5-1.3-0.8-1c-0.3,0.4,0.1,1.2,0.1,1.6C236.2,854.4,236.3,855.4,236.5,856.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M247.9,920.2c0.4-4.6,0.8-10.6,1.1-12.7c1-6.2,2.2-12.2,3.6-18.2c2.5-9.7,5.7-19.1,9.7-28.3c1-2.4,2-4.8,3-7.2 c0.3-0.6,2.1-4,1-3.9c-0.6,0.1-1.9,1.7-2.4,2.2c-0.9,0.9-1.7,1.8-2.6,2.8c-1.6,1.9-3,3.9-4.3,6c-5.3,8.9-7.2,19.1-8.7,29.2 c-1.3,10-2.1,20-2.3,30L247.9,920.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M291.8,841.5c-1.4,0.3-2.8,0.8-4.1,1.5c-1.4,0.6-2.7,1.3-4,2c-2.5,1.4-4.8,3.1-7,4.9 c-10.7,8.9-16.6,21.7-21.5,34.4c-3.8,9.9-8.1,24.3-7.9,35.9l1.2-0.1c-0.1-0.7-0.1-1.2-0.1-1.3c0.1-1.5,0.2-3,0.5-4.5 c0.6-3.6,1.5-7.1,2.6-10.6c2.4-7.2,5.2-14.2,8.5-21c5.9-12.2,13.8-23.2,23.3-32.8c2.3-2.3,4.7-4.5,7.3-6.6 C291.5,842.6,293.5,841.6,291.8,841.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M291.8,841.5c-1.4,0.3-2.8,0.8-4.1,1.5c-1.4,0.6-2.7,1.3-4,2c-2.5,1.4-4.8,3.1-7,4.9 c-10.7,8.9-16.6,21.7-21.5,34.4c-3.8,9.9-8.1,24.3-7.9,35.9l1.2-0.1c-0.1-0.7-0.1-1.2-0.1-1.3c0.1-1.5,0.2-3,0.5-4.5 c0.6-3.6,1.5-7.1,2.6-10.6c2.4-7.2,5.2-14.2,8.5-21c5.9-12.2,13.8-23.2,23.3-32.8c2.3-2.3,4.7-4.5,7.3-6.6 C291.5,842.6,293.5,841.6,291.8,841.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M293.2,875.4c-0.8-0.9-5-0.3-6-0.2c-1.8,0.3-3.6,0.7-5.3,1.4c-9.6,3.4-16.6,11.3-22.4,19.3 c-5.4,7.3-9.3,15.6-11.5,24.4l1.5,0c0.3-1.4,0.6-2.7,0.8-3.2c1-2.5,2.2-4.8,3.6-7.1c2.8-4.6,6.1-8.9,9.8-12.9 c6.5-7,14.1-12.9,22.4-17.7c1.8-1,3.6-1.9,5.5-2.6C292,876.4,293.8,876.2,293.2,875.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.2,875.4c-0.8-0.9-5-0.3-6-0.2c-1.8,0.3-3.6,0.7-5.3,1.4c-9.6,3.4-16.6,11.3-22.4,19.3 c-5.4,7.3-9.3,15.6-11.5,24.4l1.5,0c0.3-1.4,0.6-2.7,0.8-3.2c1-2.5,2.2-4.8,3.6-7.1c2.8-4.6,6.1-8.9,9.8-12.9 c6.5-7,14.1-12.9,22.4-17.7c1.8-1,3.6-1.9,5.5-2.6C292,876.4,293.8,876.2,293.2,875.4z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationMietrecht);
export default __webpack_public_path__ + "static/media/Illustration_Mietrecht.01d85919f0a87f5414d2fb17ba701a5c.svg";
export { ForwardRef as ReactComponent };